import { z } from 'zod';

export const CouponGoodsItemDtoSchema = z
  .object({
    goodsNo: z.number().int(),
    imageUrl: z.string(),
    brandName: z.string(),
    goodsName: z.string(),
    normalPrice: z.number().int(),
    price: z.number().int(),
    salesRate: z.number().int(),
    couponPrice: z.number().int().nullable(),
    couponSalesRate: z.number().int().nullable(),
    likeCount: z.number().int(),
    isLiked: z.boolean(),
    reviewScore: z.string(),
    reviewCount: z.number().int(),
    existsCoupon: z.boolean().nullish(),
    isSoldOut: z.boolean(),
    hasOptionPrice: z.boolean().nullable(),
    linkUrl: z.string(),
    totalQuantity: z.number().int().nullable(),
    extraDiscountAmount: z.number().int().nullish(),
    finalPrice: z.number().int().nullish(),
    finalDiscount: z.number().int().nullish(),
    isLowestPrice: z.boolean().nullish(),
  })
  .describe('CouponGoodsItemDto');

export type CouponGoodsItemDto = z.infer<typeof CouponGoodsItemDtoSchema>;

/**
 * 쿠폰 적용 상품 페이지 헤더 정보 + 상품 목록.
 * - status: AVAILABLE / RECEIVED / EXHAUSTED / EXPIRED
 * - isPending: useStartDate가 미래인 경우(이벤트 진행 전 상태) — owner 화면 전용 분기 키
 * - subtitleText: 카드 부제목(만료일 또는 "쿠폰 사용기간 종료" / "진행 예정 | YYYY/MM/DD ~ YYYY/MM/DD")
 */
export const GetCouponGoodsServiceRequestSchema = z
  .object({
    couponNo: z.number().int(),
    categoryCode: z.string().optional(),
    sort: z.enum(['POPULAR', 'LOW_PRICE', 'HIGH_PRICE', 'SALE_THREE_MONTH_COUNT']).optional(),
    page: z.number().int().positive().optional(),
    size: z.number().int().positive().max(100).optional(),
  })
  .describe('GetCouponGoodsServiceRequest');

export type GetCouponGoodsServiceRequest = z.infer<typeof GetCouponGoodsServiceRequestSchema>;

export const GetCouponGoodsServiceResponseSchema = z
  .object({
    isOwner: z.boolean(),
    isPending: z.boolean(),
    couponNo: z.number().int(),
    brandId: z.string(),
    couponName: z.string(),
    salesRate: z.number().int(),
    useStartDate: z.string(),
    useEndDate: z.string(),
    status: z.enum(['AVAILABLE', 'RECEIVED', 'EXHAUSTED', 'EXPIRED']),
    subtitleText: z.string(),
    list: z.array(CouponGoodsItemDtoSchema),
    pagination: z.object({
      hasNextPage: z.boolean(),
      nextPage: z.number().int().optional(),
    }),
  })
  .describe('GetCouponGoodsServiceResponse');

export type GetCouponGoodsServiceResponse = z.infer<typeof GetCouponGoodsServiceResponseSchema>;
